module.exports = __webpack_public_path__ + "static/media/profile-pic3.758cd8ca.png";